import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

import IconButton from 'components/common/IconButton';
import Menu, { MenuItem } from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import IconMoreVert from 'components/icons/IconMoreVert';
import ReferralSourceCreateEditDialog from 'components/settings/ReferralSourceCreateEditDialog';
import Link from 'components/common/Link';
import Tooltip from 'components/common/Tooltip';
import IconLink from 'components/icons/IconLink';

import splitLongWords from 'utils/splitLongWords';

import { deleteReferralSource } from 'redux/modules/referralSources';

const styles = theme => ({
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  cellPhone: {
    whiteSpace: 'nowrap',
  },
  linkCell: {
    padding: 0,
  },
  iconLink: {
    color: theme.palette.primary[500],
  },
  tooltipList: {
    textAlign: 'left',
  },
});

class ReferralSourcesTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      deleteMenuOpen: false,
      editDialogOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onDeleteMenuItemClick = this.onDeleteMenuItemClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      deleteMenuOpen: false,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.setState({
      anchorEl: null,
      editDialogOpen: true,
    });
  }

  onDeleteMenuItemClick() {
    this.setState({ deleteMenuOpen: true });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { ID, actions } = this.props;
    actions.deleteReferralSource({ ID });
    this.setState({
      deleteMenuOpen: false,
      anchorEl: null,
    });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  render() {
    const { account, classes } = this.props;
    const { anchorEl, deleteMenuOpen, editDialogOpen } = this.state;
    const open = Boolean(anchorEl);

    return (
      <TableRow>
        <TableCell>
          <Link
            breakWord
            onClick={this.onEditMenuItemClick}
          >
            {splitLongWords(this.props['Name of source'])}
          </Link>
        </TableCell>
        <TableCell>
          {this.props['Cooperate From']}
        </TableCell>
        <TableCell className={classes.cellPhone}>
          {this.props['Referral Source Contact']
            && this.props['Referral Source Contact'].filter(item => item.Phone).map(item => item.Phone).join(', ')}
        </TableCell>
        <TableCell>
          {this.props['Referral Source Contact']
            && this.props['Referral Source Contact'].filter(item => item.Email).map(item => splitLongWords(item.Email)).join(', ')}
        </TableCell>
        <TableCell className={classes.linkCell}>
          {((this.props['Sales Representative'] && this.props['Sales Representative'].length > 0)
            || (this.props.Prescriber && this.props.Prescriber.length > 0)) &&
            <Tooltip
              content={
                <div className={classes.tooltipList}>
                  {(this.props.Prescriber && this.props.Prescriber.length > 0) &&
                    <Fragment>
                      <Typography variant="caption" gutterBottom>
                        Linked Prescribers:
                      </Typography>
                      {this.props.Prescriber.map(item => (
                        <Typography key={item.ID}>
                           {`${item['First Name']} ${item['Last Name']}`}
                        </Typography>
                      ))}
                    </Fragment>
                  }
                  {(this.props['Sales Representative'] && this.props['Sales Representative'].length > 0) &&
                    <Fragment>
                      <Typography variant="caption" gutterBottom>
                        Linked Sales:
                      </Typography>
                      {this.props['Sales Representative'].map(item => (
                        <Typography key={item.ID}>
                           {`${item['First Name']} ${item['Last Name']}`}
                        </Typography>
                      ))}
                    </Fragment>
                  }
                </div>
              }
              placement="top"
            >
              <IconLink className={classes.iconLink} />
            </Tooltip>
          }
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            aria-label="More"
            aria-owns={open ? `${this.props.ID}-referral-menu` : null}
            aria-haspopup="true"
            onClick={this.onMenuButtonClick}
            tooltipContent="Open Menu"
          >
            <IconMoreVert className={classes.iconMoreVert} />
          </IconButton>
          <Menu
            id={`${this.props.ID}-referral-menu`}
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            list={!deleteMenuOpen}
            maxHeight={130}
          >
            {deleteMenuOpen ? (
              <DeleteMenu
                text="Are you sure you want to delete this referral?"
                onCancel={this.onDeleteCancel}
                onSubmit={this.onDeleteSubmit}
              />
            ) : (
              <Fragment>
                <MenuItem
                  onClick={this.onEditMenuItemClick}
                >
                  Edit
                </MenuItem>
                <MenuItem
                  onClick={this.onDeleteMenuItemClick}
                  color="warning"
                  disabled={account.Roles.filter(item =>
                    item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
                >
                  Delete
                </MenuItem>
              </Fragment>
            )}
          </Menu>
        </TableCell>
        <ReferralSourceCreateEditDialog
          form={`referralSourceEdit-${this.props.ID}`}
          open={editDialogOpen}
          ID={this.props.ID}
          initialValues={{
            'Name of source': this.props['Name of source'],
            ...this.props['Cooperate From']
              ? { 'Cooperate from': this.props['Cooperate From'] } : {},
            ...this.props['Referral Source Contact'] ? {
              'Referral Source Contact': this.props['Referral Source Contact'].map(item => ({
                ID: item.ID,
                Phone: item.Phone,
                Fax: item.Fax,
                Email: item.Email,
                'Contact Name': item['Contact Name'],
              })),
            } : {},
            ...this.props.Email ? { Email: this.props.Email } : {},
            'Sales Representative': this.props['Sales Representative'].map(item => ({
              value: item.ID,
              label: `${item['First Name']} ${item['Last Name']}`,
            })),
            'Prescriber': this.props.Prescriber.map(item => ({
              value: item.ID,
              label: `${item['First Name']} ${item['Last Name']}`,
            })),
          }}
          onClose={this.onEditDialogClose}
        />
      </TableRow>
    );
  }
}

ReferralSourcesTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  'Name of source': PropTypes.string.isRequired,
  'Cooperate From': PropTypes.string,
  'Referral Source Contact': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })),
  Email: PropTypes.string,
  actions: PropTypes.shape({
    deleteReferralSource: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
    buttonCell: PropTypes.string.isRequired,
    cellPhone: PropTypes.string.isRequired,
  }).isRequired,
};

ReferralSourcesTableRow.defaultProps = {
  'Cooperate From': null,
  Email: null,
  'Referral Source Contact': null,
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deleteReferralSource }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ReferralSourcesTableRow),
);



// WEBPACK FOOTER //
// ./src/components/settings/ReferralSourcesTable/ReferralSourcesTableRow.js